import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FooterComponent, GoBackComponent, KorviuButtonComponent, LangTranslateBarComponent } from 'shared';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [TranslateModule, FooterComponent, GoBackComponent, LangTranslateBarComponent, KorviuButtonComponent],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPageComponent {
  private _router = inject(Router);

  public onBackToHomepageClick(): void {
    this._router.navigate(['']);
  }
}
